module.exports = __webpack_public_path__ + "img/fossilImg1.1d290237.jpg";